import { useEffect, useRef } from 'react'

export function useScrollReveal() {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const el = ref.current
    if (!el) return

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const targets = entry.target.querySelectorAll('.scroll-reveal')
            targets.forEach((target) => {
              target.classList.add('revealed')
            })
            // Also reveal the container itself if it has the class
            if (entry.target.classList.contains('scroll-reveal')) {
              entry.target.classList.add('revealed')
            }
            observer.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.12 },
    )

    observer.observe(el)

    return () => observer.disconnect()
  }, [])

  return ref
}
